<b4a-nav></b4a-nav>

<div class="container-fluid">
    <router-outlet></router-outlet>
</div>


// WEBPACK FOOTER //
// ./src/app/app.component.html